// extracted by mini-css-extract-plugin
export default {"products_container":"SingleProductSlider_products_container__LooeP"};